export const DEPENDENCY_LABELS = {
  // Navigation
  administration: 'Administración',
  dependencies: 'Dependencias',

  // Actions
  createDependency: 'Crear Dependencia',
  editDependency: 'Editar Dependencia',
  toggleDependency: 'Activar/Desactivar Dependencia',
  viewDependency: 'Ver Dependencia',
  save: 'Guardar',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  close: 'Cerrar',

  // Form fields
  dependencyId: 'ID de Dependencia',
  detail: 'Detalle',
  code: 'Código',
  isAvailable: 'Disponible',
  parentId: 'Dependencia Padre',
  selectParent: 'Seleccionar Dependencia Padre',
  notSelected: 'Sin dependencia padre',
  selectDependency: 'Seleccionar Dependencia',
  dependency: 'Dependencia',
  subDependency: 'Sub Dependencia',
  editSubDependency: 'Editar Sub Dependencia',
  createSubDependency: 'Crear Sub Dependencia',
  detailOf: 'Detalle de',
  noData: 'No hay datos disponibles',
  requiredField: 'Campo requerido',

  // Table
  tableId: 'ID',
  tableDetail: 'Detalle',
  tableCode: 'Código',
  tableStatus: 'Estado',
  tableParent: 'Dependencia Padre',
  tableActions: 'Acciones',

  // Status
  active: 'Activo',
  inactive: 'Inactivo',

  // Messages
  loadingDependencies: 'Cargando dependencias...',
  noDependencies: 'No hay dependencias disponibles',
  dependencyCreated: 'Dependencia creada exitosamente',
  dependencyUpdated: 'Dependencia actualizada exitosamente',
  dependencyToggled: 'Estado de dependencia cambiado exitosamente',
  dependencyDeleted: 'Dependencia eliminada exitosamente',
  confirmToggle: '¿Está seguro de que desea cambiar el estado de esta dependencia?',
  confirmDelete: '¿Está seguro de que desea eliminar esta dependencia?',
  errorLoading: 'Error al cargar las dependencias',
  errorCreating: 'Error al crear la dependencia',
  errorUpdating: 'Error al actualizar la dependencia',
  errorToggling: 'Error al cambiar el estado de la dependencia',
  errorDeleting: 'Error al eliminar la dependencia',

  // Validation
  detailRequired: 'El detalle es obligatorio',
  codeRequired: 'El código es obligatorio',
  codeAlphanumeric: 'El código debe ser alfanumérico',
  detailMinLength: 'El detalle debe tener al menos 3 caracteres',
  codeMinLength: 'El código debe tener al menos 2 caracteres',
  codeMaxLength: 'El código no puede tener más de 9 caracteres',

  // Tooltips
  tooltipCreate: 'Crear nueva dependencia',
  tooltipEdit: 'Editar dependencia',
  tooltipToggle: 'Activar/Desactivar dependencia',
  tooltipView: 'Ver detalles de la dependencia',
  tooltipRefresh: 'Actualizar lista',
  tooltipSearch: 'Buscar dependencias',

  // Modal titles
  modalCreateTitle: 'Crear Nueva Dependencia',
  modalEditTitle: 'Editar Dependencia',
  modalViewTitle: 'Detalles de la Dependencia',
  modalDeleteTitle: 'Confirmar Eliminación'
} as const;
